import React from 'react'
import { Button as HdsButton, ButtonList as HdsButtonList } from '@postenbring/hedwig-react'

export const ButtonList = ({ listStyle = 'default', buttons }) => {

    const buttonStyles = {
        0: "primary",
        1: "secondary",
        2: "tertiary",
    }

    return (
        <HdsButtonList variant={listStyle} className='hds-mb-24-32'>
            {buttons.map((button, index) => (
                <HdsButton asChild variant={buttonStyles[index]} fullWidth={listStyle === "stretched"}>
                    <a href={button.buttonLink} target={button.buttonTarget}>{button.linkText}</a>
                </HdsButton>
            ))}

        </HdsButtonList>

    )
}
